export { default } from "./skeleton-loader"